export default __webpack_public_path__ + "static/media/aligncenter.686527af.svg";